module.exports = __webpack_public_path__ + "img/b5f90d5.jpg";